export var EAuthTokenPlatformType;
(function (EAuthTokenPlatformType) {
    EAuthTokenPlatformType[EAuthTokenPlatformType["Unknown"] = 0] = "Unknown";
    EAuthTokenPlatformType[EAuthTokenPlatformType["SteamClient"] = 1] = "SteamClient";
    EAuthTokenPlatformType[EAuthTokenPlatformType["WebBrowser"] = 2] = "WebBrowser";
    EAuthTokenPlatformType[EAuthTokenPlatformType["MobileApp"] = 3] = "MobileApp";
})(EAuthTokenPlatformType || (EAuthTokenPlatformType = {}));
export var EGamingDeviceType;
(function (EGamingDeviceType) {
    EGamingDeviceType[EGamingDeviceType["Unknown"] = 0] = "Unknown";
    EGamingDeviceType[EGamingDeviceType["StandardPC"] = 1] = "StandardPC";
    EGamingDeviceType[EGamingDeviceType["Console"] = 256] = "Console";
    EGamingDeviceType[EGamingDeviceType["PS3"] = 272] = "PS3";
    EGamingDeviceType[EGamingDeviceType["Steambox"] = 288] = "Steambox";
    EGamingDeviceType[EGamingDeviceType["Tesla"] = 320] = "Tesla";
    EGamingDeviceType[EGamingDeviceType["Handheld"] = 512] = "Handheld";
    EGamingDeviceType[EGamingDeviceType["Phone"] = 528] = "Phone";
    EGamingDeviceType[EGamingDeviceType["SteamDeck"] = 544] = "SteamDeck";
})(EGamingDeviceType || (EGamingDeviceType = {}));
